import { render, staticRenderFns } from "./WhatsappBtn.vue?vue&type=template&id=41622a82&"
import script from "./WhatsappBtn.vue?vue&type=script&lang=js&"
export * from "./WhatsappBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports